const translations = { needHelp: 'Precisa de ajuda?', talkToBtime: 'Converse com a Btime' }

export default translations
